<script lang="ts">
  import { toast, type Toast } from "./toast.svelte";
  import Kreuz from "./Kreuz.svelte";

  // Reactive list — re-renders when the store changes.
  const list = $derived(toast.all);

  function tone(kind: Toast["kind"]): string {
    // Opaker Hintergrund (bg-bg-elev statt /X), damit der Text ueber
    // beliebigem Page-Content lesbar bleibt -- die Pille darunter ist
    // bewusst durchsichtig (Liquid-Glass), Toasts sind aber Mitteilungen
    // mit Lese-Pflicht. Farbiger Border + Text bleibt der Tone-Hint.
    switch (kind) {
      case "success":
        return "border-success/40 bg-bg-elev text-success";
      case "error":
        return "border-danger/40 bg-bg-elev text-danger";
      case "info":
      default:
        return "border-border bg-bg-elev text-fg";
    }
  }

  function ariaRole(kind: Toast["kind"]): string {
    // Errors get a "role=alert" so screen readers announce them
    // immediately; everything else uses "status" for less-intrusive
    // updates. Both are ARIA live regions.
    return kind === "error" ? "alert" : "status";
  }
</script>

<!--
  Sitzt unter der schwebenden Toolbar-Pille (top-2 + h-12 + ein bisschen
  Luft = ~80 px). Damit ueberlappt der Toast-Stack die Pille nicht und
  blockiert auch nicht den Settings-Button rechts. z-50 haelt ihn ueber
  Page-Content; pointer-events-none am Wrapper + pointer-events-auto an
  jedem Toast laesst Klicks durch leere Stack-Bereiche durch.
-->
<div
  class="pointer-events-none fixed top-20 right-4 z-50 flex w-[min(22rem,calc(100vw-2rem))] flex-col gap-2"
  aria-live="polite"
>
  {#each list as t (t.id)}
    <div
      role={ariaRole(t.kind)}
      class="pointer-events-auto flex items-start gap-3 rounded-lg border px-3 py-2 text-sm shadow-md {tone(
        t.kind,
      )}"
    >
      <span class="min-w-0 flex-1 [overflow-wrap:anywhere]">{t.message}</span>
      <button
        type="button"
        onclick={() => toast.dismiss(t.id)}
        aria-label="Schließen"
        class="text-fg-muted hover:text-fg shrink-0 px-1 leading-none transition"
      >
        <Kreuz />
      </button>
    </div>
  {/each}
</div>
